<script setup lang="ts">
import { TableColumn } from '@/components/Table'
import { ClickableTypography, TypographyItem } from '@/components/Typography'
import { DEVICE_ROUTES, EVENTS_ROUTES } from '@/router/routes'
import { formatTimestamp } from '@/utils/dateUtils'
import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'
import IconItem from '../../../../components/Icon/IconItem.vue'
import { EColors } from '../../../../types/constants/ColorValues'

const { t } = useI18n()

const route = useRoute()
const eventId = ref(parseInt(route.params.event_id.toString()))

const columns = computed(() => ({
    bib: { field: 'bib', label: t('event.detection.table.bib') },
    checkpoint: { field: 'checkpoint_name', label: t('event.detection.table.checkpoint') },
    device: { field: 'device_name', label: t('event.detection.table.device') },
    timestamp: { field: 'timestamp', label: t('event.detection.table.timestamp') },
    event_filter: { field: 'event_filter', label: t('event.detection.table.event_filter') },
    timer_filter: { field: 'timer_filter', label: t('event.detection.table.timer_filter') },
    withdrawal: { field: 'withdrawal', label: t('detection.model.withdrawal') }
}))
</script>

<template>
    <TableColumn :field="columns['bib'].field" :label="columns['bib'].label" v-slot="props">
        <TypographyItem
            v-if="!!props.row.withdrawal"
            :label="props.row.bib"
            :class="`has-text-${EColors.DANGER}`" />
    </TableColumn>
    <TableColumn :label="columns['device'].label" v-slot="props">
        <ClickableTypography
            :label="props.row.device_name"
            :href="DEVICE_ROUTES.buildUrl(props.row.device_id)" />
    </TableColumn>
    <TableColumn :label="columns['checkpoint'].label" v-slot="props">
        <ClickableTypography
            :label="props.row.checkpoint_name"
            :href="`${EVENTS_ROUTES.buildUrl(eventId)}?tab=1&checkpoint_id=${
                props.row.checkpoint_id
            }`" />
    </TableColumn>
    <TableColumn :label="columns['withdrawal'].label" v-slot="props">
        <IconItem v-if="!!props.row.withdrawal" icon="flag" />
    </TableColumn>
    <TableColumn :label="columns['timestamp'].label" v-slot="props">
        <TypographyItem :label="formatTimestamp(props.row.timestamp)" />
    </TableColumn>
    <TableColumn :field="columns['event_filter'].field" :label="columns['event_filter'].label" />
    <TableColumn :field="columns['timer_filter'].field" :label="columns['timer_filter'].label" />
</template>
